"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarContainer = void 0;
var _styledComponents = require("styled-components");
var CalendarContainer = exports.CalendarContainer = (0, _styledComponents.css)([".react-datepicker__month-container{width:100%;}"]);